import { render } from "./Demo.vue?vue&type=template&id=85ba6c22&scoped=true"
const script = {}

import "./Demo.vue?vue&type=style&index=0&id=85ba6c22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85ba6c22"]])

export default __exports__